document.addEventListener('DOMContentLoaded', function( ){
    mostrarGaleria()
})


function mostrarGaleria(){
    const listaImagenes = document.querySelector('.contenedor-imagenes')
    for( let i = 1; i <= 12; i++ ){
        const li = document.createElement('li')
        const imagenes = document.createElement('img')
        imagenes.src = `build/img/thumb/${i}.jpg`
        imagenes.alt = 'imagen galeria'
        imagenes.dataset.imagenId = i
        imagenes.onclick = mostrarImagen
        li.appendChild(imagenes)
        listaImagenes.appendChild(li)
    }
    
}

function mostrarImagen(event) {
    //variables
    const body = document.querySelector('body')
    const imagenID = parseInt(event.target.dataset.imagenId)
    //crear el overlay html
    const overlay = document.createElement('div')
    overlay.classList.add('overlay')
    //boton para cerrar imagen 
    const btnCerrar = document.createElement('P')
    btnCerrar.textContent = 'X'
    btnCerrar.classList.add('btn-cerrar')
    
    btnCerrar.onclick = function (){
        body.classList.remove('fija')
        overlay.remove()
    }
    // Cerrar Overlay 
    overlay.onclick = function () {
        body.classList.remove('fija')
        overlay.remove()
    }
    // Creamos la imagen y la anclamos a la ruta
    const imagen = document.createElement('img')
    imagen.src = `build/img/grande/${imagenID}.webp`

   
    body.classList.add('fija')

    
    // Añadimos los elementos al DOM
    overlay.appendChild(imagen)
    //añadimos el boton de cerrar al div
    overlay.appendChild(btnCerrar)
    body.appendChild(overlay)
}